import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_OCTOPUS_PETITION_UPDATE_CONFIG = defineFcm('octopus_petition_update_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				name: { type: 'string' },
				constraints: {
					type: 'array',
					shape: { type: 'string' },
				},
			},
		}),
	)
	.withDefault(undefined)
	.toConfig();
